import classNames from "classnames";
import Styles from "./Aboutus.module.scss";
import Banner from "../aboutus/banner/Banner";
import WeGrownLot from "../aboutus/we-grown-lot/WeGrownLot";
import JoinOurFam from "../aboutus/join-our-fam/JoinOurFam";
// import OurJourney from "../aboutus/our-journey/OurJourney";
import LeadershipTeam from "../aboutus/leadership-team/LeadershipTeam";
import AdvisorsInvesters from "../aboutus/advisors-investers/AdvisorsInvesters";
import PageMetaTags from "../common/page-meta-tags/PageMetaTags";

const ABOUT_US_DESCRIPTION =
    "Vahak is an online lorry and load booking platform that helps small and medium transport companies. Logistic companies can create an online brand for their business.";

export default function AboutUs({ isMobile }: { isMobile: boolean }) {
    return (
        <>
            <PageMetaTags
                title="Vahak - About Us"
                description={ABOUT_US_DESCRIPTION}
                keywords="truck transportation services,hire a truck driver for moving, transport directory,truck driving jobs, online truck booking, vahak, vahak app"
                canonicalUrl="https://www.vahak.in/about-us"
                ogUrl="https://www.vahak.in/about-us"
                ogImgSrc="https://d1rgemtytdlz2g.cloudfront.net/web_og_image_jan_22.png"
                ogImgAltText={ABOUT_US_DESCRIPTION}
                schemaOrgJsonUrl="/about-us"
                includeDefaultSchema={false}
                schemaType="WebPage"
            />
            <main className={classNames(Styles.aboutusMainPage)}>
                <Banner isMobile={isMobile} />

                <WeGrownLot isMobile={isMobile} />

                {/* <OurJourney isMobile={isMobile} /> */}

                <LeadershipTeam isMobile={isMobile} />

                <AdvisorsInvesters isMobile={isMobile} />

                <JoinOurFam isMobile={isMobile} />
            </main>
        </>
    );
}
